import React, {forwardRef, useRef} from 'react';
import PropTypes from 'prop-types';
import {FmlxTooltip, FmlxIcon} from 'fmlx-common-ui';
import _ from 'lodash';

import DeepWellLabel from '../../../components/DeepWellLabel';

import {Orientation} from '../../../constants/dataEnum';

import './LabwareItem.scss';
import {Size} from '../../../constants/UIComponentEnum';

const LabwareItem = forwardRef(({name, imgPath, orientation, drag, preview, isDeepWell, isFavorite, id}, ref) => {
  const helperRef = useRef();
  const labwareNameRef = useRef();

  return (
    <>
      <div
        ref={(el) => {
          drag(el);
          preview(el);
          ref(el);
        }}
        className={`labware-item ${orientation.toLowerCase()}`}
        data-id={id}
      >
        <img className="labware-item-img" alt={name} src={imgPath} />
        <span ref={labwareNameRef} className="labware-item-name">
          {isFavorite && <FmlxIcon name="StarOutlined" size={Size.XS} />}
          <FmlxTooltip title={name} placement="top">
            <span
              style={{
                width: 'fit-content',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '73%',
              }}
            >
              {name}
            </span>
          </FmlxTooltip>
          {isDeepWell ? (
            <>
              &nbsp;
              <DeepWellLabel />
            </>
          ) : (
            ''
          )}
        </span>
      </div>
      <span ref={helperRef} className="labware-item-name-helper">
        {name}
      </span>
    </>
  );
});

LabwareItem.propTypes = {
  name: PropTypes.string.isRequired,
  imgPath: PropTypes.string.isRequired,
  orientation: PropTypes.string,
  drag: PropTypes.func,
  preview: PropTypes.func,
  isDeepWell: PropTypes.bool,
  isFavorite: PropTypes.bool,
  id: PropTypes.any,
};

LabwareItem.defaultProps = {
  orientation: Orientation.LANDSCAPE,
  drag: () => {},
  preview: () => {},
  isDeepWell: false,
  isFavorite: false,
  id: '',
};

function areEqual(prevProps, nextProps) {
  return (
    prevProps.name === nextProps.name &&
    prevProps.imgPath === nextProps.imgPath &&
    prevProps.orientation === nextProps.orientation &&
    prevProps.isDeepWell === nextProps.isDeepWell &&
    _.isEqual(prevProps.isFavorite, nextProps.isFavorite) &&
    _.isEqual(prevProps.id, nextProps.id) &&
    _.isEqual(prevProps.drag, nextProps.drag) &&
    _.isEqual(prevProps.preview, nextProps.preview)
  );
}

export default React.memo(LabwareItem, areEqual);
